import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-9" }, null, -1)
const _hoisted_5 = { class: "row mb-9" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " New Schema Name ", -1)
const _hoisted_8 = { class: "col-9" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1)
const _hoisted_10 = {
  key: 0,
  class: "fv-row mb-7"
}
const _hoisted_11 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-light btn-danger btn-lg me-3 mb-9" }, " Cancel ", -1)

import { ref, nextTick } from "vue";
import RebateService from "../services/RebateService";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { Field } from "vee-validate";
import { useI18n } from "vue-i18n";
import { RebateSchemaType } from "@/core/types/RebateSchemaType";
import CategorySymbolsCollapse from "./CategorySymbolsCollapse.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SchemaDetail',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const { t } = useI18n();
const isLoading = ref(true);
const formTab = ref("rate");
const selectedSchemaID = ref<number>(0);
const selectedSchemaType = ref<number>(0);
const editableRebateSchema = ref<any>({});
const originalRebateSchema = ref<any>({});
const rebateSchemaDetailShowRef = ref<any>(null);
const schemaInfo = ref({} as any);
const schemaTable = ref({} as any);

const applyCategoryForm = ref({
  rate: {},
  commission: {},
  pips: {},
  bundleVal: {},
});

const reset = () => {
  applyCategoryForm.value = {
    rate: {},
    commission: {},
    pips: {},
    bundleVal: {},
  };

  formTab.value = "rate";
  schemaInfo.value.schemaName = "";
  schemaInfo.value.schemaNote = "";
};

const show = async (_id: number, _schemaType: number) => {
  rebateSchemaDetailShowRef.value?.show();

  isLoading.value = true;
  selectedSchemaID.value = _id;
  selectedSchemaType.value = _schemaType;

  // Prepare table: setup form and fillup with data
  try {
    const resSymbolList = await RebateService.getSymbolsList();
    originalRebateSchema.value = resSymbolList.reduce((acc, item) => {
      const category = item.category;

      if (!acc[category]) {
        acc[category] = {};
      }

      if (
        _schemaType == RebateSchemaType.Base ||
        _schemaType == RebateSchemaType.Rebate
      ) {
        acc[category][item.code] = {
          symbolCode: item.code,
          rate: 0,
          pips: 0,
          commission: 0,
        };
      } else {
        formTab.value = "bundleVal";
        acc[category][item.code] = {
          symbolCode: item.code,
          bundleVal: 0,
        };
      }
      return acc;
    }, {});

    editableRebateSchema.value = JSON.parse(
      JSON.stringify(originalRebateSchema.value)
    );

    const categoryMap = {};
    for (const item of resSymbolList) {
      categoryMap[item.code] = item.category;
    }

    if (
      _schemaType == RebateSchemaType.Rebate ||
      _schemaType == RebateSchemaType.Base
    ) {
      if (_schemaType == RebateSchemaType.Base) {
        schemaInfo.value = await RebateService.getRebateBaseSchemaById(_id);
        schemaTable.value = schemaInfo.value.rebateBaseSchemaItems;
      } else if (_schemaType == RebateSchemaType.Rebate) {
        schemaInfo.value = await RebateService.getRebateSchema(_id);
        schemaTable.value = schemaInfo.value.rebateDirectSchemaItems;
      }

      schemaTable.value.forEach(function (item: {
        symbolCode: string | number;
        rate: any;
        pips: any;
        commission: any;
      }) {
        if (
          categoryMap[item.symbolCode] !== undefined &&
          editableRebateSchema.value[categoryMap[item.symbolCode]][
            item.symbolCode
          ] !== undefined
        ) {
          editableRebateSchema.value[categoryMap[item.symbolCode]][
            item.symbolCode
          ] = {
            symbolCode: item.symbolCode,
            rate: item.rate,
            pips: item.pips,
            commission: item.commission,
          };
        }
      });
    } else {
      schemaInfo.value = await RebateService.getRebateSchemaBundleById(_id);
      const symbols = Object.keys(schemaInfo.value.items);
      for (const symbol of symbols) {
        if (
          categoryMap[symbol] !== undefined &&
          editableRebateSchema.value[categoryMap[symbol]][symbol] !== undefined
        ) {
          editableRebateSchema.value[categoryMap[symbol]][symbol] = {
            symbolCode: symbol,
            bundleVal: schemaInfo.value.items[symbol],
          };
        }
      }
    }
    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const postSchema = async () => {
  const data = {
    RebateRuleItems: Object.keys(editableRebateSchema.value).reduce(
      (result: any, category) => {
        const symbols = editableRebateSchema.value[category];
        Object.keys(symbols).forEach((symbol) => {
          // If the schema type is Base || Rebate
          if (
            selectedSchemaType.value == RebateSchemaType.Base ||
            selectedSchemaType.value == RebateSchemaType.Rebate
          ) {
            const { symbolCode, rate, pips, commission } = symbols[symbol];
            result.push({ symbolCode, rate, pips, commission });
          } else {
            result[symbols[symbol].symbolCode] = symbols[symbol].bundleVal;
          }
        });
        return result;
      },
      selectedSchemaType.value == RebateSchemaType.Base ||
        selectedSchemaType.value == RebateSchemaType.Rebate
        ? []
        : {}
    ),
  };

  try {
    if (selectedSchemaType.value == RebateSchemaType.Rebate) {
      await RebateService.putRebateSchema(selectedSchemaID.value, {
        name: schemaInfo.value.name,
        note: schemaInfo.value.note,
      });
      await RebateService.putRebateSchemaItems(
        selectedSchemaID.value,
        data.RebateRuleItems
      );
    } else if (selectedSchemaType.value == RebateSchemaType.Base) {
      await RebateService.putRebateBaseSchema(selectedSchemaID.value, {
        name: schemaInfo.value.name,
        note: schemaInfo.value.note,
      });
      await RebateService.putRebateBaseSchemaItems(
        selectedSchemaID.value,
        data.RebateRuleItems
      );
    } else {
      await RebateService.putRebateSchemaBundle(selectedSchemaID.value, {
        name: schemaInfo.value.name,
        note: schemaInfo.value.note,
        type: selectedSchemaType.value,
        items: data.RebateRuleItems,
      });
    }

    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      emits("refresh");
      hide();
      reset();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const hide = () => {
  rebateSchemaDetailShowRef.value?.hide();
};

const onUpdateSymbol = ({
  category,
  symbolKey,
  formTab: tab,
  value,
}: {
  category: string;
  symbolKey: string;
  formTab: string;
  value: any;
}) => {
  if (
    editableRebateSchema.value?.[category]?.[symbolKey] &&
    editableRebateSchema.value[category][symbolKey][tab] !== undefined
  ) {
    editableRebateSchema.value[category][symbolKey][tab] = value;
  }
};

const onApplyCategory = ({
  category,
  formTab: tab,
  value,
}: {
  category: string;
  formTab: string;
  value: any;
}) => {
  Object.keys(editableRebateSchema.value[category]).forEach((symbolKey) => {
    editableRebateSchema.value[category][symbolKey][tab] = value;
  });
};

const onUpdateApplyInput = ({
  category,
  formTab: tab,
  value,
}: {
  category: string;
  formTab: string;
  value: any;
}) => {
  if (!applyCategoryForm.value[tab]) applyCategoryForm.value[tab] = {};
  applyCategoryForm.value[tab][category] = value;
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "rebateSchemaDetailShowRef",
    ref: rebateSchemaDetailShowRef,
    title: 'Schema Detail',
    "is-loading": isLoading.value,
    width: 1300,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_LoadingRing)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schemaInfo.value.name) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schemaInfo.value.name) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.note,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schemaInfo.value.note) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.note,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schemaInfo.value.note) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              (
            selectedSchemaType.value === _unref(RebateSchemaType).Rebate ||
            selectedSchemaType.value === _unref(RebateSchemaType).Base
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("ul", _hoisted_11, [
                      _createElementVNode("li", _hoisted_12, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'rate' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (formTab.value = 'rate'))
                        }, "Rate", 2)
                      ]),
                      _createElementVNode("li", _hoisted_13, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'pips' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (formTab.value = 'pips'))
                        }, "Pips", 2)
                      ]),
                      _createElementVNode("li", _hoisted_14, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'commission' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (formTab.value = 'commission'))
                        }, "Commission", 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(CategorySymbolsCollapse, {
                schema: editableRebateSchema.value,
                "form-tab": formTab.value,
                "apply-category-form": applyCategoryForm.value,
                "initial-collapsed": true,
                onUpdateSymbol: onUpdateSymbol,
                onApplyCategory: onApplyCategory,
                onUpdateApplyInput: onUpdateApplyInput
              }, null, 8, ["schema", "form-tab", "apply-category-form"]),
              _createElementVNode("div", { class: "mt-13 d-flex flex-row-reverse" }, [
                _hoisted_15,
                _createElementVNode("button", {
                  class: "btn btn-light btn-success btn-lg me-3 mb-9",
                  onClick: postSchema
                }, " Update ")
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})